/** Slider photos from `public/` — shared by site background slider and calculator hero frame. */
export const CALCULATOR_SLIDER_IMAGES = [
  '/pexels-pixabay-262047.jpg',
  '/pexels-bluerhinomedia-2788792.jpg',
  '/pexels-brett-sayles-2339712.jpg',
  '/pexels-wb2008-2290070.jpg',
  '/pexels-imin-technology-276315592-12935100.jpg',
  '/pexels-pixabay-260922.jpg',
  '/pexels-imin-technology-276315592-12935077.jpg',
];

export const CALCULATOR_HERO_BACKGROUND_IMAGE = CALCULATOR_SLIDER_IMAGES[0];
